import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { UseOutletContextInventory } from '../Inventory';
import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { Container } from '../../../../styles/container.style';
import { Category } from '../../../../models/category.model';
import { CategoryDA } from '../../../../services/admin/category.service';
import { ServiceDA } from '../../../../services/admin/service.service';
import { ProductDA } from '../../../../services/admin/product.service';
import { Message } from '../../../../models/message.model';
import { StorageCenterDA } from '../../../../services/admin/storage.center.service';
import { GlobalSwal } from '../../../../styles/swal.style';
import { Error } from '../../../../models/error.model';
import { getError, getMessage } from '../../../../languages/translations/response';
import { categorySelected } from '../../../../scripts/list.selected.script';
import { modalShow } from '../../../../utils/modal.util';
import { errorWebHandler } from '../../../../scripts/error.web.handler.script';

export interface AppInventoryListHeaderProps {
  inventory: string,
  filter: {search: string, options: any},
  setFilter: Function,
  checked: {count: number, list: string[]},
  loadInventory: Function
};

let errorResponse: Error, messageResponse: Message;

const AppInventoryListHeader: React.FunctionComponent<AppInventoryListHeaderProps> = ({inventory, filter, setFilter, checked, loadInventory}) => {
  const {companyForUser, categoriesForCompany, storageCentersForCompany, loadServicesForCompany, loadProductsForCompany, setCategoriesForCompany} = UseOutletContextInventory()
  const {lang} = StateLanguage()

  const submitDeleteList = () => {
    if (companyForUser && categoriesForCompany && inventory === 'category') {
      GlobalSwal.fire({
        title: lang.labels.youWantToDeleteSelectedCategories,
        text: lang.labels.youWillNotBeAbleToUndo,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: lang.labels.yesDelete,
        cancelButtonText: lang.labels.noCancel
      }).then(async (result) => {
        if (result.isConfirmed) {
          await CategoryDA.deleteCategories(companyForUser.id, checked.list).then( (response) => {
            if (response.status === 200) {
              messageResponse = response.data

              loadInventory(companyForUser.id, () => {
                setCategoriesForCompany(categoriesForCompany.filter((temp) => !checked.list.includes(temp.id)))

                GlobalSwal.fire({
                  title: getMessage(messageResponse.message, lang.code),
                  text: lang.labels.actionCompletedReturningToPage,
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 2200
                })
              })
            } else {
              errorResponse = response.data

              GlobalSwal.fire({
                title: getError(errorResponse.code, lang.code, errorResponse.message),
                text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
                icon: 'error',
                confirmButtonText: lang.labels.okGotIt
              })
            }
          }).catch( (error) => {
            errorWebHandler(lang, error)
          })
        }
      })
    }
    if (companyForUser && inventory === 'service') {
      GlobalSwal.fire({
        title: lang.labels.youWantDeleteSelectedServices,
        text: lang.labels.youWillNotBeAbleToUndo,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: lang.labels.yesDelete,
        cancelButtonText: lang.labels.noCancel
      }).then(async (result) => {
        if (result.isConfirmed) {
          await ServiceDA.deleteServices(companyForUser.id, checked.list).then( (response) => {
            if (response.status === 200) {
              messageResponse = response.data

              loadInventory(companyForUser.id, () => {
                loadServicesForCompany(companyForUser.id)

                GlobalSwal.fire({
                  title: getMessage(messageResponse.message, lang.code),
                  text: lang.labels.actionCompletedReturningToPage,
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 2200
                })
              })
            } else {
              errorResponse = response.data

              GlobalSwal.fire({
                title: getError(errorResponse.code, lang.code, errorResponse.message),
                text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
                icon: 'error',
                confirmButtonText: lang.labels.okGotIt
              })
            }
          }).catch( (error) => {
            errorWebHandler(lang, error)
          })
        }
      })
    }
    if (companyForUser && inventory === 'product') {
      GlobalSwal.fire({
        title: lang.labels.youWantDeleteSelectedProducts,
        text: lang.labels.youWillNotBeAbleToUndo,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: lang.labels.yesDelete,
        cancelButtonText: lang.labels.noCancel
      }).then(async (result) => {
        if (result.isConfirmed) {
          await ProductDA.deleteProducts(companyForUser.id, checked.list).then( (response) => {
            if (response.status === 200) {
              messageResponse = response.data

              loadInventory(companyForUser.id, () => {
                loadProductsForCompany(companyForUser.id)

                GlobalSwal.fire({
                  title: getMessage(messageResponse.message, lang.code),
                  text: lang.labels.actionCompletedReturningToPage,
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 2200
                })
              })
            } else {
              errorResponse = response.data

              GlobalSwal.fire({
                title: getError(errorResponse.code, lang.code, errorResponse.message),
                text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
                icon: 'error',
                confirmButtonText: lang.labels.okGotIt
              })
            }
          }).catch( (error) => {
            errorWebHandler(lang, error)
          })
        }
      })
    }
    if (companyForUser && inventory === 'storage') {
      GlobalSwal.fire({
        title: lang.labels.youWantToDeleteTheStorageCenters,
        text: lang.labels.youWillNotBeAbleToUndo,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: lang.labels.yesDelete,
        cancelButtonText: lang.labels.noCancel
      }).then(async (result) => {
        if (result.isConfirmed) {
          await StorageCenterDA.deleteStorageCenters(companyForUser.id, checked.list).then( (response) => {
            if (response.status === 200) {
              messageResponse = response.data

              loadInventory(companyForUser.id, () => {
                GlobalSwal.fire({
                  title: getMessage(messageResponse.message, lang.code),
                  text: lang.labels.actionCompletedReturningToPage,
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 2200
                })
              })
            } else {
              errorResponse = response.data

              GlobalSwal.fire({
                title: getError(errorResponse.code, lang.code, errorResponse.message),
                text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
                icon: 'error',
                confirmButtonText: lang.labels.okGotIt
              })
            }
          }).catch( (error) => {
            errorWebHandler(lang, error)
          })
        }
      })
    }
  }

  const handleChangeSearch = (event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    if (companyForUser) {
      filter.search = event.target.value
      filter.options.category = ''
      filter.options.sort_field= ''
      filter.options.sort_mode = ''
      setFilter({search: filter.search, options: {...filter.options}})
      loadInventory(companyForUser.id, () => {})
    }
  }

  const executeServiceCategory = (item: string) => {
    if (companyForUser) {
      filter.search = ''
      filter.options.category = item
      filter.options.sort_field= ''
      filter.options.sort_mode = ''
      setFilter({search: filter.search, options: {...filter.options}})
      loadInventory(companyForUser.id, () => {})
    }
  }

  const executeShowModalCategoryCreate = () => {
    modalShow('modal-category-create')
  }

  const executeShowModalStorageCenterCreate = () => {
    modalShow('modal-storage-center-create')
  }

  function categories(): Category[] {
    switch (inventory) {
      case 'service':
        return categoriesForCompany?.filter((item) => ((item.services?.length ?? 0) > 0)) || []
      case 'product':
        return categoriesForCompany?.filter((item) => ((item.products?.length ?? 0) > 0)) || []
      default:
        return []
    }
  }

  return (
    <div className="card-header">
      <div className="card-title">
        <div className="d-flex align-items-center position-relative">
          <span className="svg-icon svg-icon-1 position-absolute ms-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
              <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
            </svg>
          </span>
          <input className="form-control w-350px ps-14" type="text" autoComplete="off" placeholder={lang.labels[`search${inventory.charAt(0).toUpperCase()}${inventory.slice(1)}` as keyof typeof lang.labels]} value={filter.search} onChange={handleChangeSearch} />
        </div>
      </div>
      <div className="card-toolbar">
        <Container property={(checked.count === 0).toString()}>
          <div className="d-flex justify-content-end align-items-center">
            { categoriesForCompany && (inventory === "service" || inventory === "product") &&
              <Dropdown>
                <Dropdown.Toggle variant="select2 select2-container select2-container--bootstrap5 select2-container--below select2-container--focus select2-container--open w-200px p-0 me-2">
                  <span className="selection">
                    <span className="select2-selection select2-selection--single form-select">
                      <span className="select2-selection__rendered" role="textbox">
                        {categorySelected(categoriesForCompany, filter.options.category)}
                      </span>
                    </span>
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu variant="select2-container select2-container--bootstrap5 select2-container--open w-100" align="end">
                  <span className="select2-dropdown select2-dropdown--below">
                    <span className="select2-results">
                      <ul className="select2-results__options" role="listbox">
                        <li className={`select2-results__option select2-results__option--selectable ${filter.options.category.length === 0 && "select2-results__option--selected"}`} role="option" aria-selected={filter.options.category.length === 0}>
                          <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => executeServiceCategory("")}>{lang.labels.all}</Dropdown.Item>
                        </li>
                        { categories().map (( (item, index) => { return (
                          <li key={index} className={`select2-results__option select2-results__option--selectable ${item.id === filter.options.category && "select2-results__option--selected"}`} role="option" aria-selected={item.id === filter.options.category}>
                            <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => executeServiceCategory(item.id)}>{item.display_name}</Dropdown.Item>
                          </li>
                        )}))}
                      </ul>
                    </span>
                  </span>
                </Dropdown.Menu>
              </Dropdown>
            }
            { inventory === "category" &&
              <button className="btn btn-primary" type="button" onClick={executeShowModalCategoryCreate}>
                <div className="d-flex align-items-center">
                  <span className="svg-icon svg-icon-2 ms-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="black" />
                      <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="black" />
                      <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="black" />
                    </svg>
                  </span>
                  {lang.labels.addCategory}
                </div>
              </button>
            }
            { (inventory === "service" || inventory === "product") &&
              <Link to={"/main/inventory/" + inventory + "/create"} className="btn btn-primary">
                <div className="d-flex align-items-center">
                  <span className="svg-icon svg-icon-2 ms-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="black" />
                      <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="black" />
                      <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="black" />
                    </svg>
                  </span>
                  {lang.labels[`add${inventory.charAt(0).toUpperCase()}${inventory.slice(1)}` as keyof typeof lang.labels]}
                </div>
              </Link>
            }
            { inventory === "storage" && storageCentersForCompany && storageCentersForCompany.length >= 2 &&
              <button className="btn btn-light-primary me-2" type="button" onClick={() => modalShow('modal-storage-transfer')}>
                <div className="d-flex align-items-center">
                  <span className="svg-icon svg-icon-2 ms-0">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.4 7L13.6 3.2C13.2 2.8 12.6 2.8 12.2 3.2C11.8 3.6 11.8 4.2 12.2 4.6L14.8 7.2H3C2.4 7.2 2 7.6 2 8.2C2 8.8 2.4 9.2 3 9.2H14.8L12.2 11.8C11.8 12.2 11.8 12.8 12.2 13.2C12.6 13.6 13.2 13.6 13.6 13.2L17.4 9.4C18.2 8.6 18.2 7.8 17.4 7Z" fill="black"/>
                      <path opacity="0.3" d="M6.6 17L10.4 20.8C10.8 21.2 11.4 21.2 11.8 20.8C12.2 20.4 12.2 19.8 11.8 19.4L9.2 16.8H21C21.6 16.8 22 16.4 22 15.8C22 15.2 21.6 14.8 21 14.8H9.2L11.8 12.2C12.2 11.8 12.2 11.2 11.8 10.8C11.4 10.4 10.8 10.4 10.4 10.8L6.6 14.6C5.8 15.4 5.8 16.2 6.6 17Z" fill="black"/>
                    </svg>
                  </span>
                  {lang.labels.stockTransfer}
                </div>
              </button>
            }
            { inventory === "storage" &&
              <button className="btn btn-primary" type="button" onClick={executeShowModalStorageCenterCreate}>
                <div className="d-flex align-items-center">
                  <span className="svg-icon svg-icon-2 ms-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="black" />
                      <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="black" />
                      <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="black" />
                    </svg>
                  </span>
                  {lang.labels.addStorageCenter}
                </div>
              </button>
            }
          </div>
        </Container>
        <Container property={(checked.count > 0).toString()}>
          <div className="d-flex justify-content-end align-items-center">
            <div className="fw-bolder me-5">
              <span className="me-2">{checked.count}</span>
              {lang.labels.selected}
            </div>
            <button className="btn btn-danger" type="button" onClick={submitDeleteList}>{lang.labels.deleteSelected}</button>
          </div>
        </Container>
      </div>
    </div>
  )
};

export default AppInventoryListHeader;
